module.exports = __webpack_public_path__ + "static/media/Amal Mahrouki Headshot.6db266f8.jpeg";